export type CanonicalHostId =
  | "rex"
  | "milo"
  | "knox";

export type HostVisualState =
  | "idle"
  | "intro"
  | "presenting"
  | "suspense"
  | "reveal"
  | "reaction"
  | "celebrate"
  | "signoff";

export interface CanonicalHostDefinition {
  readonly id:
    CanonicalHostId;

  readonly displayName:
    string;

  readonly title:
    string;

  readonly tagline:
    string;

  readonly assetPrefix:
    "REX" | "MILO" | "KNOX";
}

export const CANONICAL_HOSTS:
readonly CanonicalHostDefinition[] = [
  {
    id:
      "rex",

    displayName:
      "Rex",

    title:
      "The Show Stealer",

    tagline:
      "Every night deserves to become a legendary story.",

    assetPrefix:
      "REX",
  },

  {
    id:
      "milo",

    displayName:
      "Milo",

    title:
      "Chaos Goblin",

    tagline:
      "Why worry about what might happen… when we can find out together?",

    assetPrefix:
      "MILO",
  },

  {
    id:
      "knox",

    displayName:
      "Knox",

    title:
      "The Instigator",

    tagline:
      "I'm not starting trouble… I'm just pointing out the opportunities.",

    assetPrefix:
      "KNOX",
  },
];

export function isCanonicalHostId(
  value:
    string,
): value is CanonicalHostId {
  return (
    value === "rex" ||
    value === "milo" ||
    value === "knox"
  );
}

export function resolveCanonicalHost(
  value:
    string,
): CanonicalHostDefinition | undefined {
  if (!isCanonicalHostId(value)) {
    return undefined;
  }

  return CANONICAL_HOSTS.find(
    (host) =>
      host.id === value,
  );
}

export function hostAvatarAsset(
  hostId:
    CanonicalHostId,
): string {
  const host =
    resolveCanonicalHost(
      hostId,
    );

  if (!host) {
    throw new Error(
      `Unknown canonical host: ${hostId}`,
    );
  }

  return (
    `/assets/hosts/${host.id}/` +
    `${host.assetPrefix}_avatar-default.png`
  );
}

export function hostKeyframeAsset(
  hostId:
    CanonicalHostId,
  state:
    HostVisualState,
): string {
  const host =
    resolveCanonicalHost(
      hostId,
    );

  if (!host) {
    throw new Error(
      `Unknown canonical host: ${hostId}`,
    );
  }

  return (
    `/assets/hosts/${host.id}/` +
    `${host.assetPrefix}_keyframe_${state}.png`
  );
}